var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticStyle:{"max-width":"100%"}},[_c('validation-observer',[_c('global-events'),(_vm.error)?_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"mt-10 text-center",attrs:{"cols":"auto"}},[_vm._v(" "+_vm._s(_vm.error)+" ")])],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }